import { useNavigate } from "react-router-dom";

import {
  buildDashboardSnapshot,
  deriveHighestVerificationTier,
} from "../../lib/dashboard";
import { suggestedUpgrade, useVerifiedStore } from "../../stores/verified";

import { TierExplainerModal } from "./tier-explainer-modal";

export function GlobalTierExplainer() {
  const navigate = useNavigate();
  const isOpen = useVerifiedStore((s) => s.isExplainerOpen);
  const closeExplainer = useVerifiedStore((s) => s.closeExplainer);

  if (!isOpen) return null;

  const tier = deriveHighestVerificationTier(buildDashboardSnapshot());
  const suggested = suggestedUpgrade(tier);

  return (
    <TierExplainerModal
      open
      onOpenChange={(open) => {
        if (!open) closeExplainer();
      }}
      currentTier={tier}
      suggestedUpgrade={suggested}
      onPrimaryCta={() => {
        // bank-verified without entitlement is gated by the modal's
        // `isPrimaryCtaDisabled`; we should not be reachable here in that case.
        closeExplainer();
        if (suggested === "document-backed") {
          navigate("/dashboard?view=documents");
          return;
        }
        if (suggested === "bank-verified") {
          // Plaid connect entry point; entitlement-gated upstream.
          navigate("/dashboard?view=documents&source=plaid");
          return;
        }
      }}
    />
  );
}
